import React, { useEffect, useState } from "react";

const Venus = () => {
  const [animate, setAnimate] = useState(false);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setAnimate(true);
  }, []);

  const projects = [
    {
      name: "MoneyMint",
      intro:
        "Moneymint is a financial management platform allowing users to manage expenses and bills in one place.",
      img: require("../images/MoneyMint.png"),
      link: "https://github.com/navyamalhotra78/MoneyMint",
    },
    {
      name: "EyeSpy",
      intro:
        "EYESPY is a public safety surveillance system aimed to detect acts of violence, fires and accidents and send real time alerts to authorities.",
      img: require("../images/Eyespy.png"),
      link: "https://github.com/navyamalhotra78/MajorProject",
    },
    {
      name: "Ekta",
      intro:
        "EKTA aims to showcase India's rich cultural heritage by bringing into sotlight local atrisans and lesser explored nooks to boost experience economy and tourism.",
      img: require("../images/Ekta.jpg"),
      link: "https://github.com/navyamalhotra78/EKTA",
    },
    {
      name: "Too Good to Go",
      intro:
        '"Too Good To Go" is a nonprofit web app that connects NGOs with people in need via delivery agents.',
      img: require("../images/TGTG.png"),
      link: "https://github.com/navyamalhotra78/Too-Good-To-Go",
    },
    {
      name: "Facility Management",
      intro:
        "Facility Management System is a web application for utility management in large institutions to linearize the flow of maintenance work.",
      img: require("../images/Facility.png"),
      link: "https://github.com/navyamalhotra78/FacilityManagementSystem",
    },
    {
      name: "Padhae",
      intro:
        "This website aims to improve rural education by providing access to knowledge and mentors at the fingertips of all children.",
      img: require("../images/Padhae.png"),
      link: "https://github.com/navyamalhotra78/padha-e",
    },
     {
      name: "Stock Market Analyser",
      intro:
        "Built a real-time stock market dashboard using live financial data to visualize trends, track performance, and support informed investment decisions.",
      img: require("../images/StockMarket.png"),
      link: "https://github.com/navyamalhotra78/padha-e",
    },
     {
      name: "AI Server Health Monitor",
      intro:
        "Designed an AI-driven monitoring system to predict server health issues, reduce downtime, and optimize performance with real-time analytics.",
      img: require("../images/AIServer.png"),
      link: "https://github.com/navyamalhotra78/padha-e",
    },
  ];

  return (
    <section style={styles.sectionContainer}>
      <div style={styles.contentContainer}>
        <h2 style={styles.title}>🌟 Featured Projects</h2>
        <div
  style={{
    ...styles.grid,
    opacity: animate ? 1 : 0,
    transform: animate ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.6s ease, transform 0.6s ease',
  }}
>
  {(showAll ? projects : projects.slice(0, 6)).map((project, index) => (
    <div
      key={index}
      style={{
        ...styles.card,
        animation: animate ? `slideIn 0.6s ease forwards` : 'none',
        animationDelay: `${index * 0.1}s`,
      }}
      onClick={() => window.open(project.link, '_blank')}
    >
      <img src={project.img} alt={project.name} style={styles.image} />
      <h3 style={styles.projectTitle}>{project.name}</h3>
      <p style={styles.projectIntro}>{project.intro}</p>
      <button
        style={styles.button}
        onClick={(e) => {
          e.stopPropagation();
          window.open(project.link, '_blank');
        }}
      >
        View Project
      </button>
    </div>
  ))}
</div>

{/* View More / Show Less Button */}
{projects.length > 6 && (
  <div style={{ marginTop: '40px', textAlign: 'center' }}>
    <button
      style={styles.arrowButton}
      onClick={() => setShowAll(!showAll)}
      className="arrow-button"
    >
      {showAll ? '↑' : '↓'}
    </button>
  </div>
)}

      </div>

      <style>{`
        @keyframes slideIn {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        button:hover {
          box-shadow: 0 0 15px 4px #dcb0ffcc;
          transform: scale(1.05);
          transition: all 0.3s ease-in-out;
        }
           @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-6px);
    }
  }

  .arrow-button:hover {
    transform: scale(1.2);
    text-shadow: 0 0 20px #fbc2eb;
  }
      `}</style>
    </section>
  );
};

const styles = {
  sectionContainer: {
    padding: "30px 20px",
    display: "flex",
    justifyContent: "center",
    background: "transparent",
    marginTop: "-60px",
  },
  contentContainer: {
    width: "100%",
    maxWidth: "1200px",
    color: "white",
    textAlign: "center",
  },
  title: {
    fontSize: "2.5rem",
    color: "#fbc2eb",
    marginBottom: "40px",
    fontWeight: "790",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "30px",
    padding: "0 20px",
  },
  card: {
    cursor: "pointer",
    padding: 0,
    background: "none",
    borderRadius: 0,
    boxShadow: "none",
    transition: "transform 0.3s ease",
  },
  image: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderRadius: "12px",
    marginBottom: "10px",
    boxShadow: "0 0 12px rgba(251, 194, 235, 0.25)",
  },
  projectTitle: {
    fontSize: "1.2rem",
    margin: "10px 0 5px",
    color: "#fbc2eb",
    textShadow: "0 0 4px rgba(251, 194, 235, 0.4)",
  },
  projectIntro: {
    fontSize: "0.95rem",
    marginBottom: "10px",
    lineHeight: "1.4",
    color: "#e9dff7",
  },
  button: {
    padding: "8px 16px",
    background: "linear-gradient(90deg, #dcb0ff, #fbc2eb)",
    color: "#1a0f25",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 0 10px #dcb0ff88",
    transition: "all 0.3s ease-in-out",
  },
  arrowButton: {
  background: 'transparent',
  color: '#fbc2eb',
  fontSize: '2rem',
  border: 'none',
  cursor: 'pointer',
  animation: 'float 1.8s ease-in-out infinite',
  transition: 'transform 0.3s ease',
  textShadow: '0 0 10px rgba(251, 194, 235, 0.5)',
},

};

export default Venus;
